import React, { Component } from 'react';

import ConfirmDeleteButton from '../../../Common/Buttons/ConfirmDeleteButton';
import isPresent from '../../../Common/Utils/Present';
import StatusIconMedium from '../../../Common/Icons/StatusMedium';

type Props = {
  expandIcon: any,
  fields: any,
  handleRemove: any,
  handleTouchTap: any,
  index: number,
  record: any
};

class MonitorCheckHead extends Component<Props> {
  render() {
    let active = true;
    let metric;
    let min;
    let max;
    let count;

    if (isPresent(this.props.record.checks[this.props.index])) {
      let monitorCheck = this.props.record.checks[this.props.index]
      active = monitorCheck.active;

      if (monitorCheck.metric) {
        metric = <span style={{ paddingLeft: 10 }}>{monitorCheck.metric}</span>;
      }

      if (monitorCheck.min) {
        min = <span style={{ paddingLeft: 10 }}>Min: {monitorCheck.min}</span>;
      }

      if (monitorCheck.max) {
        max = <span style={{ paddingLeft: 10 }}>Max: {monitorCheck.max}</span>;
      }

      if (monitorCheck.count) {
        count = <span style={{ paddingLeft: 10 }}>Count: {monitorCheck.count}</span>;
      }
    } else {
      metric = <span style={{ paddingLeft: 10 }}>New Monitor Check</span>;
    }

    return (
      <div>
        <div onClick={() => this.props.handleTouchTap(this.props.index)} style={{ cursor: 'pointer', backgroundColor: '#f5f5f5', padding: 15 }}>
          <StatusIconMedium enabled={active} style={{ paddingTop: 10 }} />
          {metric}
          {min}
          {max}
          {count}
          <span style={{ paddingLeft: 10 }}>{this.props.expandIcon}</span>

          <div style={{ float: 'right' }}>
            <ConfirmDeleteButton onClick={(event) => this.props.handleRemove(event, this.props.index)} />
          </div>
        </div>
      </div>
    )
  }
};

export default MonitorCheckHead;



// WEBPACK FOOTER //
// ./src/views/Components/Monitors/Partials/MonitorCheckHead.tsx